var map = {
	"./hisense/Device": 1037,
	"./lg/Device": 1640,
	"./nagra/Device": 1649,
	"./netrange/Device": 1660,
	"./opera/Device": 1668,
	"./ps4/Device": 1676,
	"./samsung/Device": 1684,
	"./seirobotics/Device": 1692,
	"./sony/Device": 1702,
	"./stbcoship/Device": 1710,
	"./tizen/Device": 1715,
	"./web0s/Device": 1724,
	"./workstation/Device": 671,
	"./zeasn/Device": 1738
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1036;


//////////////////
// WEBPACK FOOTER
// ./src/devices ^\.\/.*\/Device$
// module id = 1036
// module chunks = 0